<template>
  <div class="wrapper" id="offerTesting">
    <main class="contentModule">
      <div>
        <!--<button class="homePage" onmouseover="this.style.backgroundColor='#eff1f5';" onmouseout="this.style.backgroundColor='#ffffff';" onmouseup="this.style.backgroundColor='#f3f7fd';">返回用户中心</button>-->
        <div class="mainContent">
          <div class="theme">测一测</div>
          <div class="explain">轻松测算关税保证保险的保费成本，企业信息输入安全保密，承诺绝不用作其他用途</div>
          <ul>
            <li class="amount">
              <div>过往12个月纳税总额</div>
              <div>
                <span>500万</span>
                <span>1000万</span>
                <span>1500万</span>
                <span>2000万</span>
                <span>自定义</span>
              </div>
              <div class="block">
                <el-slider
                  v-model="amountModel"
                  :step="20"
                  :show-stops="true"
                  :show-tooltip="false"
                  @change="amountChange"
                >
                </el-slider>
              </div>
            </li>
            <li class="creditRatings">
              <div>海关登记信用级别</div>
              <div>
                <span>一般信用</span>
                <span>一般认证</span>
                <span>高级认证</span>
              </div>
              <div class="block">
                <el-slider
                  v-model="creditRatingsModel"
                  :step="34"
                  show-stops
                  :show-tooltip="false"
                  @change="creditRatingsChange">
                </el-slider>
              </div>
            </li>
            <li class="insurancePeriod">
              <div>保险期限</div>
              <div>
                <span>1个月</span>
                <span>3个月</span>
                <span>6个月</span>
                <span>9个月</span>
                <span>12个月</span>
              </div>
              <div class="block">
                <el-slider
                  v-model="insurancePeriodModel"
                  :step="20"
                  show-stops
                  :show-tooltip="false"
                  @change="insurancePeriodChange">
                </el-slider>
              </div>
            </li>
            <li class="insurancePurposes">
              <div>保单用途</div>
              <div>
                <span>汇总征税担保</span>
                <span>纳税期限担保</span>
                <span>征税要素担保</span>
              </div>
              <div class="block">
                <el-slider
                  v-model="insurancePurposesModel"
                  :step="34"
                  show-stops
                  :show-tooltip="false"
                  @change="insurancePurposesChange">
                </el-slider>
              </div>
            </li>
          </ul>
          <div class="calculate">
            <el-dialog
              :visible.sync="showViewer"
              width="30%"
              center
              class="promptContainer">
              <span slot="footer" class="dialog-footer">
               <div class="promptTitle">自定义金额</div>
                <div class="promptContent">
                  <div>请输入过往12个月纳税总额数值</div>
                  <div>（单位：万元）</div>
                       <el-input
                         style="border-bottom: 2px solid #DCDFE6;margin-top: 20px;"
                         class="insureAmount"
                         placeholder="0,000"
                         @keyup.native="amount = changeSaleNum(amount)"
                         v-model="amount"
                       >
                  </el-input>
                </div>
                <div class="button" >
                  <button  @click="affirm()" style="width: 150px;height:50px;margin-top: 20px;border: 0px solid #DCDFE6;" class="affirm" onmouseover="this.style.backgroundColor='#49A9EE';" onmouseout="this.style.backgroundColor='#108DE9';" onmouseup="this.style.backgroundColor='#177FCF';">确认</button>
                </div>
             </span>
            </el-dialog>

            <el-dialog
              :visible.sync="showViewerTwo"
              width="30%"
              center
            class="promptContainer">
              <span slot="footer" class="dialog-footer">
                <div class="promptTitle" style="border-bottom: 2px solid #CCCCCC">测算结果</div>
                  <div class="promptContent parameter">
                      <div>
                          <span>过往12个月纳税总额：</span>
                          <span> {{this.amount}}万元</span>
                      </div>
                      <div>
                          <span>预估保费：</span>
                          <span>{{this.premium}} 元</span>
                      </div>
                      <div>
                          <span>保单用途：</span>
                          <span>{{this.tariffPolicyPurposeList[this.insurancePurposes]}}</span>
                      </div>
                      <div>
                          <span>保险期限：</span>
                          <span>{{this.insurancePeriod}} 个月</span>
                      </div>
                      <div class="warmPrompt">温馨提示：测算结果仅供参考，最终保费将以实际投保为准</div>
                  </div>
                  <div class="button space-around ">
                      <button class="close"  @click="showViewerTwo = false" onmouseover="this.style.backgroundColor='#eff1f5';" onmouseout="this.style.backgroundColor='#ececec';" onmouseup="this.style.backgroundColor='#f2f7fe';">关闭</button>
                      <button class="fillInfo" @click="insure" onmouseover="this.style.backgroundColor='#49A9EE';" onmouseout="this.style.backgroundColor='#108DE9';" onmouseup="this.style.backgroundColor='#177FCF';">我要投保</button>
                  </div>
             </span>
            </el-dialog>
            <button  @click="submit()" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">测算</button>
          </div>
        </div>
      </div>
    </main>

    <!-- 自定义弹窗 -->
    <div class="prompt" hidden>
      <div class="shadow"></div>
      <div class="promptContainer">

      </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'offerTesting',
        data(){
            return{
                showViewer:false,
                showViewerTwo:false,
                premium : 0,
                amount: "",
                creditRatings: "",
                insurancePeriod: "",
                insurancePurposes: "",
                amountModel: 0,
                creditRatingsModel: 0,
                insurancePeriodModel: 0,
                insurancePurposesModel: 0,
                tariffPolicyPurposeList: ['', '汇总征税担保', '纳税期限担保', '征税要素担保']
            }
        },
        methods: {
            insure(){
                this.$router.push({name: 'dutyInsuranceFillInfo'});
            },
            affirm(){
                this.showViewer = false;
                this.amountModel = 100;
            },
            get_thousand_num(num) {
                return num.toString().replace(/\d+/, function (n) { // 先提取整数部分
                    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) { // 对整数部分添加分隔符
                        return $1 + ",";
                    });
                });
            },
            changeSaleNum(value) {
                let length = value.length;
                value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
                value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
                let valueList = value.split('.');
                if (valueList[0].length > 9) value = valueList[0].substring(0,9) + (this.$$.isValidObj(valueList[1]) ? '.'+valueList[1] : '');
                if (value.indexOf(".") < 0 && value !== "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                    value = parseFloat(value);
                }
                value = this.get_thousand_num(value);
                return value;
            },
            premiumCalculation(totalTax = 0, creditRating = 1, insurancePeriod = 1){
                const insuredAmount = totalTax * 1.05;
                const annualizedRate = (function(){
                    if(section(totalTax, 0, 500)){
                        return {3: 0.85, 2: 1.60, 1: 2.40};
                    }else if(section(totalTax, 501, 2000)){
                        return {3: 0.70, 2: 1.30, 1: 2.00};
                    }else if(section(totalTax, 2001, 5000)){
                        return {3: 0.60, 2: 1.05, 1: 1.60};
                    }else if(section(totalTax, 5001, 20000)){
                        return {3: 0.50, 2: 0.85, 1: 1.25};
                    }else if(section(totalTax, 20001, 50000)){
                        return {3: 0.35, 2: 0.65, 1: 0.90};
                    }else if(section(totalTax, 50001, 100000)){
                        return {3: 0.25, 2: 0.40, 1: 0.60};
                    }else if(totalTax > 100000){
                        return {3: 0.12, 2: 0.22, 1: 0.30};
                    }
                    function section(current, min, max){
                        return Math.max(min, current) == Math.min(current, max);
                    }
                })()[creditRating] / 100;
                const shortTermRate = (function(){
                    const datums = {
                        1: 0.15,
                        3: 0.25,
                        6: 0.50,
                        9: 0.75,
                        12: 1.00
                    };
                    return datums[insurancePeriod];
                })();
                const premium = insuredAmount * annualizedRate * shortTermRate;
                if(!premium) return 0;
                return premium * 10000;
            },
            submit(){
                let isValidate =  this.validateParameter(0);
                if(isValidate != false){
                    let reg = new RegExp(",","g");
                    let tax = this.amount.toString().replace(reg, '');
                    console.log(this.premiumCalculation(tax, this.creditRatings, this.insurancePeriod).toFixed(2) * 0.70);
                    this.premium = this.premiumCalculation(tax, this.creditRatings, this.insurancePeriod).toFixed(2) * 0.70;
                    this.showViewerTwo = true;
                }
            },
            validateParameter(states = 0) {
                if (this.amount == 0){
                    this.$message.error("请先选择过往12个月纳税总额~" );
                    if (states == 1){
                        this.insurancePurposesModel = 0;
                    }
                    return false;
                } else if (this.creditRatings ==  0){
                    this.$message.error("请先选择海关登记信用级别~" );
                    if (states == 1){
                        this.insurancePurposesModel = 0;
                    }
                    return false;
                } else if (this.insurancePeriod ==  0){
                    this.$message.error("请先选择保险期限~" );
                    if (states == 1){
                        this.insurancePurposesModel = 0;
                    }
                    return false;
                } else if (this.insurancePurposes == 0){
                    this.$message.error("请先选择保单用途~" );
                    if (states == 1){
                        this.insurancePurposesModel = 0;
                    }
                    return false;
                }
                return true;
            },
            amountChange(value){
                console.log(value);
                let totalTaxList = [0, 500, 1000, 1500, 2000, -1],
                    index = 0;
                index = this.switchIndex(value , 1);
                if ( totalTaxList[index] == -1){
                    this.amountModel = 0;
                    this.showViewer = true;
                }else{
                    this.amount = totalTaxList[index];
                }

                console.log(this.amount);


                // let totalTaxList = [0, 500, 1000, 1500, 2000, 0],
                //     temporaryAmount = 0;

            },
            creditRatingsChange(value){
                let creditRatingsList = [0, 1, 2, 3 ],
                    index = 0;

                index = this.switchIndex(value , 2);
                this.creditRatings = creditRatingsList[index];
                console.log(this.creditRatings);
                console.log(value);
            },
            insurancePeriodChange(value){
                let insurancePeriodList =  [0, 1, 3, 6, 9, 12],
                    index = 0;
                index = this.switchIndex(value , 1);
                this.insurancePeriod = insurancePeriodList[index];
                console.log(this.insurancePeriod);
                console.log(value);
            },
            insurancePurposesChange(value){
                console.log(value);
                let insurancePurposesList =  [0, 1, 2, 3],
                    index = 0;
                index = this.switchIndex(value , 2);
                this.insurancePurposes = insurancePurposesList[index];
                if (this.insurancePurposes == 3){
                    this.validateParameter(1);
                }
                this.submit();
            },
            switchIndex(value , type){
                let listIndex = 0;
                if(type == 1 ){
                    switch (value) {
                        case 20:{
                            listIndex = 1;
                            break;
                        }
                        case 40:{
                            listIndex = 2;
                            break;
                        }
                        case 60:{
                            listIndex = 3;
                            break;
                        }
                        case 80:{
                            listIndex = 4;
                            break;
                        }
                        case 100:{
                            listIndex = 5;
                            break;
                        }
                    }
                }
                if(type == 2 ){
                    switch (value) {
                        case 34:{
                            listIndex = 1;
                            break;
                        }
                        case 68:{
                            listIndex = 2;
                            break;
                        }
                        case 100:{
                            listIndex = 3;
                            break;
                        }
                    }
                }
                return listIndex;
            }

        }
    }
</script>
<style scoped>
  @import "../../../../static/css/dutyInsurance/offerTesting.css";
  @import "../../../../static/css/reset.css";

  .wrapper /deep/ .el-input__inner{
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/dutyInsurance/offerTesting.vue